// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'
import ConfirmModal from 'ui/molecules/ConfirmModal'

import useAuditLog from '../hooks'

type Props = { compact?: boolean }

const ActionRow = tw.div`
  bg-gray-50
  border-t
  border-l
  border-r
  border-gray-200
  font-medium
  leading-4
  pl-4
  pr-32
  py-3
  text-gray-500
  text-left
  text-xs
  tracking-wider
  uppercase

   ${({ $compact }: { $compact?: boolean }) => {
     if ($compact) {
       return `
        py-2
        pl-2
        pr-1
      `
     }

     return ''
   }}
`

function AuditLogsAction({ compact }: Props): React.Node {
  const { restartSelectedsAuditLog, selectedAuditLogs } = useAuditLog()
  const [modalAction, setModalAction] = React.useState<'restart' | void>(
    undefined
  )

  return (
    <ActionRow compact={compact}>
      <Flex justify="between">
        <Flex $horizontalSpacing="medium" align="center" justify="between">
          <Button
            $block
            $compact
            $danger
            disabled={selectedAuditLogs.length === 0}
            onClick={() => {
              if (selectedAuditLogs.length > 0) {
                setModalAction('restart')
              }
            }}
          >
            Restart Selected Integration
          </Button>
        </Flex>
      </Flex>
      <ConfirmModal
        cancelText="Cancel"
        confirmText={modalAction === 'restart' ? 'Restart' : ''}
        message={
          modalAction === 'restart'
            ? 'Are you sure you want to restart the selected integrations?'
            : ''
        }
        onCancel={() => {
          setModalAction(undefined)
        }}
        onConfirm={() => {
          if (modalAction) {
            if (modalAction === 'restart') {
              restartSelectedsAuditLog()
            }
            setModalAction(undefined)
          }
        }}
        showConfirm={modalAction !== undefined}
        title={modalAction === 'restart' ? 'Restart Integrations' : ''}
      />
    </ActionRow>
  )
}

export default AuditLogsAction
